export default "__VITE_ASSET__rf4oB0yQ__"